import { render, staticRenderFns } from "./CargoNormal.vue?vue&type=template&id=5c5b276a&scoped=true"
import script from "./CargoNormal.vue?vue&type=script&lang=js"
export * from "./CargoNormal.vue?vue&type=script&lang=js"
import style0 from "./CargoNormal.vue?vue&type=style&index=0&id=5c5b276a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b276a",
  null
  
)

export default component.exports